import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import {
  applicationHistoryKey,
  applicationsCountsKey,
  employerApplicationsKey,
  errorMessage,
  inviteToInterviewRoute,
} from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { eventsInterviewKey } from '@features/events';

type UseInviteToInterviewProps = {
  setErrorText: Dispatch<SetStateAction<string>>;
  onSuccess?: () => void;
};

export const useInviteToInterview = ({
  setErrorText,
  onSuccess,
}: UseInviteToInterviewProps) => {
  const client = useQueryClient();

  const { mutate: inviteToInterview, isLoading: isInviteToInterviewLoading } =
    useMutation({
      mutationFn: (variables: {
        invitee_id: number;
        application_id: number;
        body: string;
        start_time: number | string | null | 0;
        end_time: number | string | null | 0;
        eventDate: string;
        position: string;
        physical_interview_address: string | boolean;
        physical_interview_location: string;
        virtual_interview_link: string;
        block_type: number;
      }) =>
        axiosInstance
          .post(inviteToInterviewRoute, variables)
          .then((res) => res.data),
      onSuccess: (data) => {
        if (data.status === 200) {
          client.invalidateQueries(employerApplicationsKey);
          client.invalidateQueries(applicationsCountsKey);
          client.invalidateQueries(eventsInterviewKey);
          client.invalidateQueries(applicationHistoryKey);
          onSuccess?.();
          setErrorText('');
        } else {
          setErrorText(data?.message || errorMessage);
        }
      },
      onError: (error: { message?: string }) => {
        setErrorText(error?.message || errorMessage);
      },
    });
  return {
    inviteToInterview,
    isInviteToInterviewLoading,
  };
};
